"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RadioGroup = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _ValidationTooltip = require("../Tooltip/_ValidationTooltip");
var _FormField = require("../FormField/_FormField");
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _useUniqueId = require("../utils/useUniqueId");
var _constants = require("../utils/constants");
var _RadioGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./RadioGroup.css") : void 0);
var _excluded = ["children", "className", "childRadioLabelClass", "decorators", "disabled", "headingProps", "tailContainerProps", "inline", "label", "labelProps", "layout", "inputProps", "inputDescribedby", "name", "onChange", "controlProps", "controlContainerProps", "readOnly", "required", "size", "validationMessage", "validationOverlayProps"],
  _excluded2 = ["inputClassName", "theme", "isFocused"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-radio-group';

/**
 * **RadioGroup** groups a collection of radio buttons into a single input value.
 *
 * **Radio** is a specialized form control that emits an `<input>` with a type of radio.
 *
 * **RadioGroup** provides users with a set of mutually exclusive options.
 * It allows a user to select only one option from two or more choices.
 * Each option is represented by a radio button.
 * Consequently, radio buttons only work in groups.
 * */

var RadioGroup = exports.RadioGroup = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context2, _validationOverlayPro;
  var addChildPropsFromContextAbove = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildPropsFromContextAbove ? _objectSpread(_objectSpread({}, _props), addChildPropsFromContextAbove(RadioGroup, _props)) : _props;
  var children = props.children,
    className = props.className,
    childRadioLabelClass = props.childRadioLabelClass,
    decorators = props.decorators,
    disabled = props.disabled,
    headingProps = props.headingProps,
    tailContainerProps = props.tailContainerProps,
    inline = props.inline,
    label = props.label,
    labelProps = props.labelProps,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'vertical' : _props$layout,
    inputProps = props.inputProps,
    inputDescribedby = props.inputDescribedby,
    name = props.name,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
    controlProps = props.controlProps,
    controlContainerProps = props.controlContainerProps,
    readOnly = props.readOnly,
    required = props.required,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    validationMessage = props.validationMessage,
    validationOverlayProps = props.validationOverlayProps,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_RadioGroup.default);
  var groupId = (0, _useUniqueId.useUniqueId)();
  if (controlProps !== null && controlProps !== void 0 && controlProps.id) groupId = controlProps.id;
  var labelId = (0, _useUniqueId.useUniqueId)();
  if (labelProps !== null && labelProps !== void 0 && labelProps.id) labelId = labelProps.id;
  var validationId = (0, _useUniqueId.useUniqueId)();
  var addChildProps = function addChildProps(child, childProps, attributes) {
    if (child.displayName === 'Radio') {
      return _objectSpread(_objectSpread({}, attributes), {}, {
        disabled: typeof childProps.disabled !== 'undefined' ? childProps.disabled : disabled,
        readOnly: typeof childProps.readOnly !== 'undefined' ? childProps.readOnly : readOnly,
        name: childProps.name || name || groupId,
        required: required,
        size: size,
        onChange: childProps.onChange || onChange,
        state: validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.state,
        labelClassName: classnames(childProps === null || childProps === void 0 ? void 0 : childProps.labelClassName, childRadioLabelClass)
      });
    }
    return {};
  };
  var getHeadingStartDecorators = function getHeadingStartDecorators() {
    var _context;
    var decoratorArray = [];
    if (!disabled && !readOnly && validationMessage !== null && validationMessage !== void 0 && validationMessage.text && validationMessage !== null && validationMessage !== void 0 && validationMessage.state) {
      decoratorArray.push( /*#__PURE__*/_react.default.createElement(_ValidationTooltip.ValidationTooltip, {
        size: size,
        state: validationMessage.state,
        text: validationMessage.text
      }));
    }
    return (0, _concat.default)(_context = []).call(_context, (0, _toConsumableArray2.default)(_react.default.Children.toArray(decorators === null || decorators === void 0 ? void 0 : decorators.headingStart)), decoratorArray);
  };
  var renderRadioInputs = function renderRadioInputs(_ref) {
    var inputClassName = _ref.inputClassName,
      theme = _ref.theme,
      isFocused = _ref.isFocused,
      attributes = (0, _objectWithoutProperties2.default)(_ref, _excluded2);
    return /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
      value: function value(child, childProps) {
        return addChildProps(child, childProps, attributes);
      }
    }, children);
  };
  var getInputDescribedBy = function getInputDescribedBy() {
    var describedByArr = [];
    if (validationMessage !== null && validationMessage !== void 0 && validationMessage.text) {
      describedByArr.push(validationId);
    }
    if (inputDescribedby) {
      describedByArr.push(inputDescribedby);
    }
    return describedByArr.length > 0 ? describedByArr.join(' ') : undefined;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FormField.FormField, (0, _extends2.default)({}, otherProps, {
    className: classnames(CSS_BLOCK, className, (0, _defineProperty2.default)({}, (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "--")).call(_context2, layout), layout !== 'vertical')),
    disabled: disabled,
    decorators: _objectSpread(_objectSpread({}, decorators), {}, {
      headingStart: getHeadingStartDecorators()
    }),
    headingProps: _objectSpread(_objectSpread({}, headingProps), {}, {
      className: classnames("".concat(CSS_BLOCK, "__heading"), headingProps === null || headingProps === void 0 ? void 0 : headingProps.className)
    }),
    tailContainerProps: _objectSpread(_objectSpread({}, tailContainerProps), {}, {
      className: classnames("".concat(CSS_BLOCK, "__tail-container"), tailContainerProps === null || tailContainerProps === void 0 ? void 0 : tailContainerProps.className)
    }),
    label: label,
    labelProps: _objectSpread(_objectSpread({}, labelProps), {}, {
      id: labelId,
      className: classnames("".concat(CSS_BLOCK, "__label"), labelProps === null || labelProps === void 0 ? void 0 : labelProps.className)
    }),
    layout: layout,
    inputId: groupId,
    inputDescribedby: getInputDescribedBy(),
    readOnly: readOnly,
    ref: ref,
    controlContainerProps: _objectSpread(_objectSpread({}, controlContainerProps), {}, {
      className: classnames("".concat(CSS_BLOCK, "__control-container"), controlContainerProps === null || controlContainerProps === void 0 ? void 0 : controlContainerProps.className)
    }),
    controlProps: _objectSpread(_objectSpread({
      role: 'radiogroup'
    }, controlProps), {}, {
      'aria-labelledby': labelId,
      overrideControlClasses: true,
      className: classnames("".concat(CSS_BLOCK, "__container"), controlProps === null || controlProps === void 0 ? void 0 : controlProps.className, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__container--inline"), inline), "".concat(CSS_BLOCK, "__container--disabled"), disabled)),
      id: groupId
    }),
    renderInput: renderRadioInputs,
    required: required,
    size: size,
    validationOverlayProps: _objectSpread(_objectSpread({}, validationOverlayProps), {}, {
      targetClassName: classnames("".concat(CSS_BLOCK, "__overlay"), validationOverlayProps === null || validationOverlayProps === void 0 || (_validationOverlayPro = validationOverlayProps.targetClassName) === null || _validationOverlayPro === void 0 ? void 0 : _validationOverlayPro.className)
    })
  })), (validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text) && /*#__PURE__*/_react.default.createElement("div", {
    className: classnames("".concat(CSS_BLOCK, "--screen-reader-only")),
    id: validationId
  }, validationMessage === null || validationMessage === void 0 ? void 0 : validationMessage.text));
});
RadioGroup.displayName = 'RadioGroup';
RadioGroup.propTypes = _objectSpread(_objectSpread({}, _FormField.FormField.propTypes), {}, {
  /** @ignore, prop is only for FormField */
  inputId: _CustomPropTypes.default.notDefined,
  /** @ignore, prop is only for FormField */
  renderInput: _CustomPropTypes.default.notDefined,
  /** @ignore, used by Toolbar */
  childRadioLabelClass: _propTypes.default.string,
  /** When `true`, **Radio** buttons will be shown on the same row rather than stacked. */
  inline: _propTypes.default.bool,
  /** Set to toggle the layout of the heading, control and additional help text.
   * Options are `'vertical'` (default) or `'horizontal`'. */
  layout: _propTypes.default.oneOf(_FormField.LAYOUT_TYPES),
  /** Sets the `name` attribute on the `<input>` elements
   * (same name will be applied to each radio button) */
  name: _propTypes.default.string,
  /** Size of the component. Options are `'lg'` and `'md'`. */
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /**
   * Callback function for onChange events. This can be used as a
   * single callback shared by each `Radio` child component.
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   */
  onChange: _propTypes.default.func
});
var _default = exports.default = RadioGroup;